import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, Phone, Mail } from "lucide-react";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigation = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Locations", path: "/locations" },
    { name: "Contact", path: "/contact" }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-neutral-900/95 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/fvpheq93_IMG_0584.png" 
              alt="Hudson Knox" 
              className="h-12 w-auto brightness-0 invert"
            />
            <span className="ml-3 text-xs tracking-widest text-neutral-300 uppercase">Outdoor Living</span>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm tracking-wide transition-colors duration-200 ${
                  location.pathname === item.path
                    ? "text-white font-medium"
                    : "text-neutral-300 hover:text-white"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center space-x-6">
            <a href="tel:07846923387" className="flex items-center space-x-2 text-neutral-300 hover:text-white transition-colors">
              <Phone className="h-4 w-4" />
              <span className="text-sm">07846 923387</span>
            </a>
            <Link to="/contact">
              <Button className="bg-white text-neutral-900 hover:bg-neutral-100 transition-all duration-200">
                Free Quote
              </Button>
            </Link>
          </div>

          <button
            className="lg:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-neutral-900 border-t border-neutral-800">
          <div className="px-4 py-6 space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-base ${
                  location.pathname === item.path
                    ? "text-white font-medium"
                    : "text-neutral-300"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 space-y-3 border-t border-neutral-800">
              <a href="tel:07846923387" className="flex items-center space-x-2 text-neutral-300">
                <Phone className="h-4 w-4" />
                <span>07846 923387</span>
              </a>
              <a href="mailto:admin@hudsonknox.co.uk" className="flex items-center space-x-2 text-neutral-300">
                <Mail className="h-4 w-4" />
                <span>admin@hudsonknox.co.uk</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};
